import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../context/authcontext";
import { useFlash } from "../../context/flashcontext";
import { useCustomerDetail } from "../../hooks/useCustomerDetail";
import CustomerDetailView from "./CustomerDetailView";

function CustomerDetailContainer() {
    const { id } = useParams();
    const { auth } = useAuth();
    const { showFlash } = useFlash();
    const customerDetail = useCustomerDetail(id);

    const handleSaveClick = async (editableCustomer) => {
        try {
            await customerDetail.handleSaveClick(editableCustomer);
            showFlash("Klant bijgewerkt.", "success");
        } catch {
            showFlash("Bijwerken mislukt.", "error");
        }
    };

    return (
        <CustomerDetailView
            {...customerDetail}
            auth={auth}
            onSaveClick={handleSaveClick}
        />
    );
}

export default CustomerDetailContainer;

CustomerDetailContainer.propTypes = {
    // No props - uses hooks internally
};
